import { render } from "./CroppedImageField.vue?vue&type=template&id=17bef7d4"
import script from "./CroppedImageField.vue?vue&type=script&lang=js"
export * from "./CroppedImageField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CroppedImageField.vue"]])

export default __exports__